<template>
  <div class="w100">
    <span class="version">Version: {{ version }}</span>

    <!-- <div class="FondoTriangulos">
      <div class="w100 aliCenter h100 dIB">
        <div class="Triangulo1"></div>
        <div class="Triangulo2"></div>
      </div>
    </div> -->
    <div class="Centro w100 dIB">
      <div ref="SeccionLogin" class="wrapper PosIncial0 TransitionAll1">
        <div class="rec-prism">
          <!-- LOGIN -->
          <div class="face face-front oHidden">
            <div class="w100 aliCenter">
                  <img ref="LogoAgroIdeas" class="LogoAgroideas TransitionAll07 PosIncial1" src="../assets/logo-agroideas.png" />
            </div>
            <div class="content aliCenter mT10">
              <!-- <div class="TituloLogin B">Login</div> -->
              <div class="">
                <div class="field-wrapper">
                  <!-- <input type="text" v-on:keyup="Prueba()" v-model="Usuario._Name" name="username" placeholder="username"> -->
                  <input
                    type="text"
                    v-model="Usuario._Name"
                    name="username"
                    placeholder="username"
                  />
                  <label>Nombre de Usuario</label>
                </div>
                <div class="field-wrapper">
                  <input
                    v-model="Usuario._Pass"
                    v-on:keyup.13="IntentarLogin()"
                    type="password"
                    name="password"
                    placeholder="password"
                    autocomplete="new-password"
                  />
                  <label>Contraseña</label>
                </div>
                <div class="field-wrapper">
                  <button class="Boton" v-on:click="IntentarLogin()">Entrar</button>
                </div>
                <!-- <span class="psw" v-on:click="showForgotPassword()">Olvidaste la contraseña?</span>
                <span class="signup" v-on:click="showSignup()">Nuevo Usuario?  Registrate</span> -->
              </div>
            </div>
            <div class="w100 aliCenter">
                <img ref="LogoMaiz" class="LogoMaizPlus TransitionAll07 PosIncial2" src="../assets/logo-maiz-plus.png" alt="LogoMaizPlus">
            </div>
          </div>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
import axios from "axios";
import Clases from "../Auxiliares/Clases.js";

export default {
  name: "Login",
  data() {
    return {
      Usuario: {
        _Name: process.env.VUE_APP_USERNAME,
        _Pass: process.env.VUE_APP_PASSWORD,
      },
    };
  },
  mounted() {
    //console.log(process.env.NODE_ENV);
    Clases.EliminarJsonDelStorage(this.$parent.Datos.KeyUser());
    setTimeout(() => {
        this.$refs.SeccionLogin.classList.add("PosFinal0");
        this.$refs.LogoAgroIdeas.classList.add("PosFinal1");
        this.$refs.LogoMaiz.classList.add("PosFinal2");
      }, 100);
    // if (this.$parent.Datos._User == null){
    //   setTimeout(() => {
    //     this.$refs.SeccionLogin.classList.add("PosFinal0");
    //     this.$refs.LogoAgroIdeas.classList.add("PosFinal1");
    //     this.$refs.LogoMaiz.classList.add("PosFinal2");
    //   }, 100);
    // }else{
    //   window.location.href = "/";
    // }
  },
  methods: {
    showSignup() {
      let prism = document.querySelector(".rec-prism");
      prism.style.transform = "translateZ(-100px) rotateY( -90deg)";
    },
    showBienvenido() {
      let prism = document.querySelector(".rec-prism");
      prism.style.transform = "translateZ(-100px) rotateY( -90deg)";
    },
    IntentarLogin() {
      if (this.Usuario._Name.length > 0 && this.Usuario._Pass.length > 0) {
        var _This = this;
        axios
          .post(process.env.VUE_APP_API_URL + "/users/login", {
            name: _This.Usuario._Name,
            pass: _This.Usuario._Pass,
          })
          .then(function(response) {
            let _User = response.data;
            //console.log(_User);
            if (_User._Nick != null) {
              Clases.GuardarJsonEnStorage(_This.$parent.Datos.KeyUser(), _User);
              //window.location.href = "/";
              _This.$parent.Datos._User = _User;
              _This.$router.push("/");
              //let _GUI = _This.$parent.$children.find(child => { return child.$options.name === "GUI"; });
              //TODO: revisar acá, no está encontrando a _GUI
              //_GUI.ValidarInfo();
            } else {
              _This.$parent.Notificacion("Datos incorrectos", "", "error", 3);
              console.log("Login INCORRECTO!");
            }
          })
          .catch(function(error) {
            console.log("asdasdasd1");
            console.log(_This.urlPosts + "/users/login");
            console.log(error);
          })
          .then(function() {});
      } else {
        alert(2);
      }
    },
    Prueba() {
      console.log(this.Usuario._Name);
    },
  },
  computed:{
      version(){
          return process.env.VUE_APP_VERSION;
      }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '../Css/Globales.css';
  @import '../Css/AgroIdeas.scss';

$prism-height: 420px;
$prism-length: 350px;
$prism-depth: $prism-length;
$spacing: 20px;
$br: 3px;

$text-light: #fff;
$text-dark: #666;
$blue: #03a9f4;
$smoke: #f9f9fa;
$coral: #ff5751;
$navy-blue: #42509e;
$green: #65af26;

* {
  box-sizing: border-box;
}

.version{
  position: fixed;
  bottom: 5px;
  right: 5px;
}

.PosIncial0{
  opacity: 0;
}
.PosIncial1{
  margin-left: -600px;
  opacity: 0;
}
.PosIncial2{
  margin-right:-600px;
  opacity: 0;
}
.PosFinal0{
  opacity: 1;
}
.PosFinal1{
  margin-left:0;
  opacity: 1;
}
.PosFinal2{
  margin-right:0;
  opacity: 1;
}
.TituloLogin{
  font-size: 1.2em;
  color: #004867;
}
body {
  font-family: Tahoma, Verdana, Segoe, sans-serif;
  font-size: 14px;
  background: #f6fffd;
  padding: $spacing;
  text-align: center;
  margin: 0px;
}
.wrapper {
  width: 100%;
  max-width: $prism-length;
  height: $prism-height;
  margin: 10px auto;
  // perspective: 600px;
  text-align: left;
  // -webkit-transform: translate(-50%, -50%);
  // transform: translate(-50%, -50%);
  // top: 50%;
  // left: 50%;
}

.rec-prism {
  width: 100%;
  height: 100%;
  position: relative;
  transform-style: preserve-3d;
  transform: translateZ(-100px);
  transition: transform 0.5s ease-in;
  font-size: 1.1em;
}

.face {
  position: absolute;
  width: 100%;
  height: $prism-height;
  padding: 20px;
  background: rgba(250, 250, 250, 0.5);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  border-radius: 3px;

  .content {
    color: $text-dark;
    h2 {
      font-size: 1.2em;
      color: $AgroIdeas;
    }
    .field-wrapper {
      margin-top: $spacing * 1.5;
      position: relative;

      label {
        position: absolute;
        pointer-events: none;
        font-size: 0.85em;
        top: 40%;
        left: 0;
        transform: translateY(-50%);
        transition: all ease-in 0.25s;
        color: lighten($text-dark, 20%);
      }
      input[type="text"],
      input[type="password"],
      input[type="submit"],
      textarea {
        -webkit-appearance: none;
        appearance: none;
        &:focus {
          outline: none;
        }
      }
      input[type="text"],
      input[type="password"],
      textarea {
        width: 100%;
        border: none;
        background: transparent;
        line-height: 2em;
        border-bottom: 1px solid $AgroIdeas;
        color: $text-dark;

        &::-webkit-input-placeholder {
          opacity: 0;
        }
        &::-moz-placeholder {
          opacity: 0;
        }
        &:-ms-input-placeholder {
          opacity: 0;
        }
        &:-moz-placeholder {
          opacity: 0;
        }
        &:focus,
        &:not(:placeholder-shown) {
          + label {
            top: -35%;
            color: $navy-blue;
          }
        }
      }
      textarea {
        resize: none;
        line-height: 1em;
        &:focus,
        &:not(:placeholder-shown) {
          + label {
            top: -25%;
          }
        }
      }
    }
  }

  &-front {
    transform: rotateY(0deg) translateZ(calc($prism-length/2));
  }
  &-top {
    height: $prism-depth;
    transform: rotateX(90deg) translateZ(calc($prism-depth/2));
  }
  &-back {
    transform: rotateY(180deg) translateZ(calc($prism-length/2));
  }
  &-right {
    transform: rotateY(90deg) translateZ(calc($prism-length/2));
  }
  &-left {
    transform: rotateY(-90deg) translateZ(calc($prism-length/2));
  }
  &-bottom {
    height: $prism-depth;
    transform: rotateX(-90deg) translateZ($prism-height - calc($prism-depth/2));
  }
}

.nav {
  margin: $spacing 0;
  padding: 0;

  li {
    display: inline-block;
    list-style-type: none;
    font-size: 1em;
    margin: 0 calc($spacing/2);
    color: $navy-blue;
    position: relative;
    cursor: pointer;
    &:after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 20px;
      border-bottom: 1px solid $navy-blue;
      transition: all ease-in 0.25s;
    }
    &:hover:after {
      width: 100%;
    }
  }
}

.psw,
.signup,
.singin {
  display: block;
  margin: $spacing 0;
  font-size: 0.75em;
  text-align: center;
  color: $navy-blue;
  cursor: pointer;
}

small {
  font-size: 0.7em;
}
.LogoAgroideas {
  height:50px;
}
.LogoMaizPlus {
  height:75px;
  margin-top:14px;
}
</style>
